module.exports = __webpack_public_path__ + "media/theme/steps--4--open-a561c330.png";